import { APP_INITIALIZER, NgModule } from "@angular/core"
import { BrowserModule } from '@angular/platform-browser'
import { Router, RouteReuseStrategy } from "@angular/router"

import { JwtModule } from '@auth0/angular-jwt'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { AuthService } from '@/services/auth.service'
import { GuardService } from '@/services/guard.service'
import { AuthInterceptor } from '@/services/auth-interceptor.service'
import { APIInterceptor } from '@/services/api.interceptor'
import { CacheInterceptor } from '@/services/cache-interceptor.service';

import { FormsModule } from '@angular/forms'
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'
import { IonicModule, IonicRouteStrategy } from '@ionic/angular'

import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'

import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx'

import { ErrorHandler } from "@angular/core";
import * as Sentry from "@sentry/capacitor";
import * as SentryAngular from '@sentry/angular';
import { environment } from 'projects/environments/environment'
import pkgJson from '../../package.json'
import { DeviceNetworkService } from "../common/services/device-network.service"
import { OrientationService } from "../common/services/orientation.service"

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        AppRoutingModule,
        FormsModule,
        JwtModule.forRoot({
            config: {
                authScheme: '',
                tokenGetter: AuthService.token,
                allowedDomains: ["example.com"],
                disallowedRoutes: ["/api/v2/login"],
            },
        })], providers: [
        AuthService,
        GuardService,
        InAppBrowser,
        OrientationService,
        DeviceNetworkService,
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: APIInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CacheInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: ErrorHandler,
            useValue: SentryAngular.createErrorHandler(),
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
